import { render, staticRenderFns } from "./Systems.vue?vue&type=template&id=070e984d"
import script from "./Systems.vue?vue&type=script&lang=js"
export * from "./Systems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports